// extracted by mini-css-extract-plugin
export var conversationListItem = "_wx-2";
export var fullBleedList = "_wx-3";
export var messageText = "_wx-1";
export var previewText = "_wx-0";